export function clearFilters(e) {
  e.preventDefault();
  /* eslint-disable-next-line no-undef */
  const queryData = Site.serializedQueryParams();
  const params = {};

  let destination = window.location.pathname;

  if (Object.keys(queryData).includes("checkin")) {
    params.checkin = queryData.checkin;
    params.checkout = queryData.checkout;
  }
  if (Object.keys(queryData).includes("sort_by")) {
    params.sort_by = queryData.sort_by;
  }

  /* eslint-disable no-undef */
  if (Object.keys(params).length) {
    destination = `${destination}?${Site.objectToQuery(params)}`;
  }
  const existingQuery = Site.objectToQuery(queryData);
  const query = Site.objectToQuery(params);
  /* eslint-enable no-undef */

  /* uncheck resorts */
  const form = document.querySelector(".filter-open form");
  if (form) {
    form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      /* eslint-disable-next-line no-param-reassign */
      checkbox.checked = false;
    });

    form.querySelectorAll("input[data-default]").forEach(input => {
      /* eslint-disable-next-line no-param-reassign */
      input.value = input.dataset.default;
    });
  }

  this.filtersChanged();

  if (existingQuery === query) return;
  window.location = destination;
}

export function filtersChanged() {
  /* eslint-disable no-undef */
  const formData = Site.serializeFormData(this.formTarget);
  const queryData = Site.serializedQueryParams();
  /* eslint-enable no-undef */
  const params = {};
  const clearBtns = this.formTarget.querySelectorAll(".clear-filters");
  const submitBtn = this.formTarget.querySelectorAll(
    '.filter-open form button[type="submit"]'
  );

  if (formData.query && formData.query !== '') {
    params.query = formData.query.toLowerCase();
  }

  if (formData.resorts && formData.resorts.length) {
    params.resorts = formData.resorts
      .map(resort => resort.toLowerCase())
      .join(",");
  }

  if (formData.themes && formData.themes.length) {
    params.themes = formData.themes
      .map(themes => themes.toLowerCase())
      .join(",");
  }

  if (formData.entertainments && formData.entertainments.length) {
    params.entertainments = formData.entertainments
      .map(entertainment => entertainment.toLowerCase())
      .join(",");
  }

  if (formData.amenities && formData.amenities.length) {
    params.amenities = formData.amenities
      .map(amenity => amenity.toLowerCase())
      .join(",");
  }

  if (formData.neighborhoods && formData.neighborhoods.length) {
    params.neighborhoods = formData.neighborhoods
      .map(neighborhood => neighborhood.toLowerCase())
      .join(",");
  }

  if (formData.min_price && this.not_default("min_price", formData)) {
    params.min_price = formData.min_price;
  }
  if (formData.max_price && this.not_default("max_price", formData)) {
    params.max_price = formData.max_price;
  }

  if (formData.min_price && this.not_default("min_price", formData)) {
    params.min_price = formData.min_price;
  }


  if (formData.min_bedrooms && this.not_default("min_bedrooms", formData)) {
    params.min_bedrooms = formData.min_bedrooms;
  }
  if (formData.max_bedrooms && this.not_default("max_bedrooms", formData)) {
    params.max_bedrooms = formData.max_bedrooms;
  }
  if (formData.min_guests && this.not_default("min_guests", formData)) {
    params.min_guests = formData.min_guests;
  }

  delete queryData.checkin;
  delete queryData.checkout;
  delete queryData.sort_by;

  /* eslint-disable no-undef */
  // if params are same as before
  const existingQuery = Site.objectToQuery(queryData);
  const query = Site.objectToQuery(params);
  /* eslint-enable no-undef */

  submitBtn.forEach((el) => {
    el.disabled = existingQuery === query;
    el.innerText = existingQuery === query ? "Select Filters" : "Search";
  })

  // if (submitBtn) {
  //   submitBtn.disabled = existingQuery === query;
  //   submitBtn.innerText = existingQuery === query ? "Select Filters" : "Search";
  // }

  if (query !== "" || existingQuery !== "") {
    clearBtns.forEach(clearBtn => clearBtn.classList.remove("hidden"));
  } else {
    clearBtns.forEach(clearBtn => clearBtn.classList.add("hidden"));
  }
}

/* This function is used elsewhere, safer to let it remain snakecase.  */
/* eslint-disable-next-line camelcase */
export function not_default(name, params) {
  const el = this.formTarget.querySelector(`[id$=${name}]`);
  const def = el.dataset.default;
  return params[name] !== def;
}
